import { BaseBannerSerializer } from './BaseBannerSerializer';

class BannerSerializer {
  static deSerialize(data) {
    return {
      ...BaseBannerSerializer.deSerialize(data),
      backgroundColor: data.IHBFondoColor,
    };
  }
}

export { BannerSerializer };



// WEBPACK FOOTER //
// ./src/networking/serializers/BannerSerializer.js